import React, { useState } from "react";
import { useGetManageWeddingInvitationsQuery } from "../../../store/services/invitations/invitations.service";
import { Box, Button, Chip, Skeleton, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Lock } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { TemplateListWrapper } from "./styles";
import NoDataFallback from "../../../Components/NoDataFallback";
import {
	INVITATION_PRICING_PLANS_ENUM,
	INVITATION_STATUS,
	INVITATION_STATUSES,
	Invitations
} from "../../../store/services/invitations/dto/invitations.dto";
import { StyleCircle } from "../../../Components/Inputs/Settings/styles";
import { useAppSelector } from "../../../store";
import { getFullState } from "../../../store/slices/auth/auth.slice";
import ShareWeddingInvitationModal from "../../../Components/Modals/ShareModal";
import { InvitationStatusColor, PLAN_NAMES } from "../../../constants";
import { GoldCrown } from "../../Invitations/styles";

const MyInvitations = () => {
	const { user } = useAppSelector(getFullState);
	const { data, isLoading } = useGetManageWeddingInvitationsQuery({ id: user?._id as string });
	const theme = useTheme();
	const isSmallerScreen = useMediaQuery(theme.breakpoints.down("md"));
	const [shareInvitation, setShareInvitation] = useState<Invitations | null>(null);

	if (isLoading) {
		const loadingArray = new Array(6).fill(0);
		return (
			<Box display="flex" style={{ flexFlow: "row wrap" }} gap={2}>
				{loadingArray.map((_, index) => (
					<Box key={index} width={isSmallerScreen ? "100%" : "250px"}>
						<Skeleton variant={"rectangular"} height={"300px"} />
						<Skeleton variant={"text"} sx={{ fontSize: "40px" }} />
						<Skeleton variant={"text"} />
					</Box>
				))}
			</Box>
		);
	}

	if (data?.invitations.length === 0) {
		return <NoDataFallback />;
	}

	return (
		<TemplateListWrapper>
			{data?.invitations?.map(t => (
				<Link
					key={t._id}
					to={`/manageWeddingInvitation/${t._id}`}
					style={{ textDecoration: "none", color: "inherit" }}
					className={"template"}
				>
					{t.selectedPricingPlan > INVITATION_PRICING_PLANS_ENUM.FREE && <GoldCrown className={"payed"} />}
					{t.is_published && <Box></Box>}
					{t.is_private && <Lock className={"lock-icon"} />}
					<img src={t.thumbnail_01} alt="template" className={"thumbnail"} />
					<Box mt={1}>
						<Typography variant={"h6"}>{t.name}</Typography>
					</Box>{" "}
					<Box mt={1} display={"flex"} gap={1} alignItems={"center"}>
						<StyleCircle $color={InvitationStatusColor[t.status || 1]} />
						<Typography variant={"caption"}>{INVITATION_STATUSES[t.status]}</Typography>
						{t.selectedPricingPlan > INVITATION_PRICING_PLANS_ENUM.FREE && (
							<Chip
								label={PLAN_NAMES[t.selectedPricingPlan]}
								size={"small"}
								sx={{
									height: "18px",
									fontSize: "10px",
									fontWeight: 700,
									textTransform: "uppercase",
									letterSpacing: "0.4px",
									color: t.selectedPricingPlan === INVITATION_PRICING_PLANS_ENUM.SIGNATURE ? "#8B6914" : "#557189",
									backgroundColor:
										t.selectedPricingPlan === INVITATION_PRICING_PLANS_ENUM.SIGNATURE ? "#FDF3D0" : "#E8F2FA",
									"& .MuiChip-label": { padding: "0 8px" }
								}}
							/>
						)}
					</Box>
					<Box width={"100%"} mt={2} display={"flex"} gap={1}>
						<Button fullWidth variant={"outlined"} color={"primary"}>
							Manage
						</Button>
						{t.status === INVITATION_STATUS.PUBLISHED && (
							<Button
								fullWidth
								variant={"contained"}
								color={"primary"}
								onClick={e => {
									e.preventDefault();
									setShareInvitation(t);
								}}
							>
								Share
							</Button>
						)}
					</Box>
				</Link>
			))}
			{!!shareInvitation && (
				<ShareWeddingInvitationModal
					data={shareInvitation as Invitations}
					open={true}
					onClose={() => setShareInvitation(null)}
				/>
			)}
		</TemplateListWrapper>
	);
};

export default MyInvitations;
